
import { useState, useCallback } from 'react'
import type { Node, Edge } from '@xyflow/react'

export type ContextMenuTarget =
  | { type: 'pane'; position: { x: number; y: number } }
  | { type: 'node'; position: { x: number; y: number }; nodeId: string }
  | { type: 'edge'; position: { x: number; y: number }; edgeId: string }

interface UseCanvasContextMenuReturn {
  menu: ContextMenuTarget | null
  close: () => void
  onPaneContextMenu: (event: MouseEvent | React.MouseEvent) => void
  onNodeContextMenu: (event: React.MouseEvent, node: Node) => void
  onEdgeContextMenu: (event: React.MouseEvent, edge: Edge) => void
}

export function useCanvasContextMenu(): UseCanvasContextMenuReturn {
  const [menu, setMenu] = useState<ContextMenuTarget | null>(null)

  const close = useCallback(() => setMenu(null), [])

  const onPaneContextMenu = useCallback((event: MouseEvent | React.MouseEvent) => {
    event.preventDefault()
    setMenu({ type: 'pane', position: { x: event.clientX, y: event.clientY } })
  }, [])

  const onNodeContextMenu = useCallback((event: React.MouseEvent, node: Node) => {
    event.preventDefault()
    setMenu({ type: 'node', position: { x: event.clientX, y: event.clientY }, nodeId: node.id })
  }, [])

  const onEdgeContextMenu = useCallback((event: React.MouseEvent, edge: Edge) => {
    event.preventDefault()
    setMenu({ type: 'edge', position: { x: event.clientX, y: event.clientY }, edgeId: edge.id })
  }, [])

  return { menu, close, onPaneContextMenu, onNodeContextMenu, onEdgeContextMenu }
}
